<template>
  <div class="header-container">
    <!--el-image style="width: 1348px; height: 180px;" :src="url" :fit="fit">
    </el-image-->
    <el-image style="max-width:1348px;" :src="url" :fit="fit">
    </el-image>
    <div class="menu-container">
      <el-menu :default-active="activeIndex" class="my-menu" mode="horizontal" @select="handleSelect" background-color="#545c64"
        text-color="#fff" :active-text-color="activeTextColor" :router='true' style="border-bottom: none;">
        <el-menu-item class="my-menu-item" index="/main"> Home </el-menu-item>
        <el-menu-item index="/about/company">About Us</el-menu-item>
        <el-menu-item index="/business">Main Business</el-menu-item>
        <el-menu-item index="/system">Service System</el-menu-item>
        <!--el-menu-item index="/product">产品展示</el-menu-item-->
        <el-menu-item index="/case">Case Show</el-menu-item>
        <!--el-menu-item index="/contact">联系我们</el-menu-item-->
      </el-menu>
    </div>
  </div>
</template>

<script>
  //import Bus from "../api/Bus"
  export default {
    name: 'Header',
    data() {
      return {
        url: require('@/assets/header-top.png'),
        fit: 'contain',
        //fit: 'fill',
        activeIndex: '/main',
        //activeTextColor: '#ffd04b',
        activeTextColor: '#fff'
      }
    },
    methods: {
      handleSelect(index, indexPath) {
        //console.log(index);
        //console.log(indexPath);
      },
    },
    mounted: function() {
      //console.log("mounted");
      /*Bus.$on("menu",(val) =>{
        //console.log("Bus on");
        //console.log("val = ",val);
        //this.activeIndex = val;
        //this.$forceUpdate();
      })*/
      let path = this.$route.path;
      //console.log("path = ", path);
      if (path.indexOf("main") != -1) {
        this.activeIndex = '/main';
      } else if (path.indexOf("about") != -1) {
        this.activeIndex = '/about/company';
      } else if (path.indexOf("business") != -1) {
        this.activeIndex = '/business';
      } else if (path.indexOf("system") != -1) {
        this.activeIndex = '/system';
      } else if (path.indexOf("product") != -1) {
        console.log("path = "+path);
        this.activeIndex = '/product';
      } else if (path.indexOf("case") != -1) {
        this.activeIndex = '/case';
      } else if (path.indexOf("contact") != -1) {
        this.activeIndex = '/contact';
      }
    },
    created: function() {
      //console.log("created");
    },
    watch: {
      $route(to, from) {
        //console.log("to = ",to);
        //console.log("from = ",from);
        if(to.path.indexOf("about")!=-1){
          this.activeIndex = '/about/company';
        }
        else{
          this.activeIndex = to.path;
          //this.$forceUpdate();
        }
      }
    },
  }
</script>

<style scoped>
  .menu-container .el-menu--horizontal>.el-menu-item {
    border-bottom: none;
  }

  /*.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
  }*/

  .el-menu .is-active {
    background-color: #c21a17 !important;
    color: #fff;
    /* border-bottom: 0; */
    /*font-weight: bold;
    font-size: 16px;
    font-family: "microsoft yahei";*/
  }

  .my-menu-item {
    width: 100px;
  }

  .menu-container {
    background-color: #545c64;
    box-shadow: 10px 10px 5px #888888;
    margin-bottom: 10px;
  }

  .my-menu {
    max-width: 1200px;
    /*width: 1200px;*/
    margin: 0 auto;
  }

  .header-container {
    max-width: 100%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue